import * as types from "../constants/LoginConstants";
import { loginuser } from "../services/LoginService";

export const login = (email, password) => async (dispatch) => {
  dispatch({ type: types.LOGIN_REQUEST });
  try {
    const data = await loginuser(email, password);
    localStorage.setItem("admintoken", data.token);
    dispatch({ type: types.LOGIN_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response?.data?.message || error.message || "Login failed";
    dispatch({ type: types.LOGIN_FAIL, payload: message });
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("admintoken");
  dispatch({ type: types.LOGOUT });
};

export const resetAuthState = () => ({ type: types.RESET_AUTH_STATE });
